var request = require('./request');
var Promise = require('bluebird');
var config = require('./config');
var resolve = require('./resolve');

exports.GetCategoryTree = function(filter)
{
	return request.get(resolve(config.url(), '/category?filter=' + filter)).promise();
}

exports.GetTopLevelCategories = function(){
  return request.get(resolve(config.url(), "/category/toplevel")).promise();
}

exports.GetByFunderSchemes = function(funderId){
  return request.get(resolve(config.url(), '/scheme/ByFunderSchemes/?funderId=' + funderId)).promise();
  }

exports.GetByFunderGrantRounds = function(funderId){
  return request.get(resolve(config.url(), '/scheme/ByFunderGrandRounds/?funderId=' + funderId)).promise();
  }
